var _defs, _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgLogo(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    id: "Component_54_1",
    width: 148,
    height: 37.627,
    viewBox: "0 0 148 37.627",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, "\n            .cls-1{fill:#753bbc}.cls-2{fill:#4989c8}\n        "))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "PLB_logo_identity_4"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_20469",
    d: "M223.169 64.082a5.9 5.9 0 0 0-4.576 1.836 6.208 6.208 0 0 0-1.895 4.547v10.173h2.186V75.3a6.091 6.091 0 0 0 3.906 1.545h.233a5.907 5.907 0 0 0 4.314-1.836 6.339 6.339 0 0 0 1.895-4.605 6.163 6.163 0 0 0-1.778-4.431 5.8 5.8 0 0 0-4.285-1.895m3.848 6.442a3.965 3.965 0 0 1-1.224 2.886 3.873 3.873 0 0 1-2.886 1.2 3.685 3.685 0 0 1-2.8-1.2 4.106 4.106 0 0 1-1.2-2.886 4.385 4.385 0 0 1 1.2-3.09 3.581 3.581 0 0 1 2.769-1.2h.233a3.747 3.747 0 0 1 2.769 1.312 4.032 4.032 0 0 1 1.137 2.973",
    className: "cls-1",
    transform: "translate(-166.934 -55.647)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_20470",
    d: "M269.161 64.666a4.208 4.208 0 0 0-.933.67v-.9H266.1v12.24h2.3v-7.288a3.367 3.367 0 0 1 .321-1.6 4.012 4.012 0 0 1 .845-.874 2.476 2.476 0 0 1 1.545-.525h.321V64.2h-.321a4.028 4.028 0 0 0-1.953.466",
    className: "cls-1",
    transform: "translate(-201.929 -55.738)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Rectangle_4431",
    d: "M0 0H2.215V12.242H0z",
    className: "cls-1",
    transform: "translate(71.667 8.666)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_20471",
    d: "M316.088 72.57a4.172 4.172 0 0 1-3.731 2.011 4.255 4.255 0 0 1-4.285-4.2 3.943 3.943 0 0 1 1.37-3 4.106 4.106 0 0 1 2.886-1.2h.058a4.034 4.034 0 0 1 3.673 2.128l.087.175h2.478l-.437-.991a5.739 5.739 0 0 0-2.274-2.507 6.651 6.651 0 0 0-3.469-.986h-.117a6.46 6.46 0 0 0-4.635 1.953 6.264 6.264 0 0 0-.117 8.861l.175.175a6.535 6.535 0 0 0 4.576 1.866h.058a6.246 6.246 0 0 0 5.859-3.5l.408-.874h-2.478z",
    className: "cls-1",
    transform: "translate(-230.044 -55.597)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_20472",
    d: "M360.765 63.8h-.408a6 6 0 0 0-4.343 1.865 6.4 6.4 0 0 0-.114 9.035.773.773 0 0 0 .175.146 6.06 6.06 0 0 0 4.343 1.807h.087a6.336 6.336 0 0 0 5.946-4.285l.146-.466h-2.332l-.087.2a3.73 3.73 0 0 1-3.614 2.332 4.171 4.171 0 0 1-2.827-1.02 4.006 4.006 0 0 1-1.312-2.274h10.319v-1.161a6 6 0 0 0-1.749-4.139 6.285 6.285 0 0 0-4.227-2.04m3.673 5.218h-7.961a3.717 3.717 0 0 1 1.341-2.04 4.293 4.293 0 0 1 5.334.029 4.2 4.2 0 0 1 1.283 2.011",
    className: "cls-1",
    transform: "translate(-264.247 -55.455)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Rectangle_4432",
    d: "M0 0H2.215V16.294H0z",
    className: "cls-1",
    transform: "translate(104.044 4.605)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_20473",
    d: "M422.531 63.982a5.8 5.8 0 0 0-4.547 1.836 6.469 6.469 0 0 0-.146 9.007 5.958 5.958 0 0 0 4.343 1.924h.233a5.907 5.907 0 0 0 4.314-1.836 6.378 6.378 0 0 0 .146-8.978 5.986 5.986 0 0 0-4.343-1.953m3.877 6.3a4.242 4.242 0 0 1-1.224 3.09 3.663 3.663 0 0 1-2.769 1.224h-.233a3.747 3.747 0 0 1-2.769-1.312 4.109 4.109 0 0 1-1.108-2.973 4.031 4.031 0 0 1 1.224-2.915 3.791 3.791 0 0 1 2.8-1.2h.087a3.521 3.521 0 0 1 2.74 1.2 3.882 3.882 0 0 1 1.253 2.886",
    className: "cls-1",
    transform: "translate(-308.16 -55.578)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_20474",
    d: "M474.288 72.57a4.172 4.172 0 0 1-3.731 2.011 4.255 4.255 0 0 1-4.285-4.2 3.943 3.943 0 0 1 1.37-3 4.106 4.106 0 0 1 2.886-1.2h.058a4.034 4.034 0 0 1 3.673 2.128l.117.175h2.448l-.437-.991a5.739 5.739 0 0 0-2.274-2.507 6.651 6.651 0 0 0-3.469-.986h-.117a6.46 6.46 0 0 0-4.635 1.953 6.264 6.264 0 0 0-.117 8.861l.175.175a6.535 6.535 0 0 0 4.576 1.866h.058a6.246 6.246 0 0 0 5.859-3.5l.408-.845h-2.478z",
    className: "cls-1",
    transform: "translate(-342.087 -55.597)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_20475",
    d: "M520.966 65.865A6 6 0 0 0 516.623 64h-.233a6.122 6.122 0 0 0-4.343 1.924 6.258 6.258 0 0 0-1.749 4.431 6.387 6.387 0 0 0 1.895 4.605 6.207 6.207 0 0 0 8.482.262v5.334h2.215V70.413a5.975 5.975 0 0 0-1.924-4.547m-.35 4.664a4.106 4.106 0 0 1-1.2 2.886 3.79 3.79 0 0 1-2.769 1.2 3.874 3.874 0 0 1-2.886-1.2 4.014 4.014 0 0 1-1.224-2.886 4.087 4.087 0 0 1 1.108-2.944 3.8 3.8 0 0 1 2.769-1.312h.233a3.608 3.608 0 0 1 2.769 1.224 4.154 4.154 0 0 1 1.2 3.031",
    className: "cls-1",
    transform: "translate(-374.891 -55.595)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Rectangle_4433",
    d: "M0 0H2.215V2.215H0z",
    className: "cls-1",
    transform: "translate(71.667 4.605)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_20476",
    d: "M223.169 64.082a5.9 5.9 0 0 0-4.576 1.836 6.208 6.208 0 0 0-1.895 4.547v10.173h2.186V75.3a6.091 6.091 0 0 0 3.906 1.545h.233a5.907 5.907 0 0 0 4.314-1.836 6.339 6.339 0 0 0 1.895-4.605 6.163 6.163 0 0 0-1.778-4.431 5.8 5.8 0 0 0-4.285-1.895m3.848 6.442a3.965 3.965 0 0 1-1.224 2.886 3.873 3.873 0 0 1-2.886 1.2 3.685 3.685 0 0 1-2.8-1.2 4.106 4.106 0 0 1-1.2-2.886 4.385 4.385 0 0 1 1.2-3.09 3.581 3.581 0 0 1 2.769-1.2h.233a3.747 3.747 0 0 1 2.769 1.312 4.032 4.032 0 0 1 1.137 2.973",
    className: "cls-1",
    transform: "translate(-166.934 -55.647)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_20477",
    d: "M269.161 64.666a4.208 4.208 0 0 0-.933.67v-.9H266.1v12.24h2.3v-7.288a3.367 3.367 0 0 1 .321-1.6 4.012 4.012 0 0 1 .845-.874 2.476 2.476 0 0 1 1.545-.525h.321V64.2h-.321a4.028 4.028 0 0 0-1.953.466",
    className: "cls-1",
    transform: "translate(-201.929 -55.738)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Rectangle_4434",
    d: "M0 0H2.215V12.242H0z",
    className: "cls-1",
    transform: "translate(71.667 8.666)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_20478",
    d: "M316.088 72.57a4.172 4.172 0 0 1-3.731 2.011 4.255 4.255 0 0 1-4.285-4.2 3.943 3.943 0 0 1 1.37-3 4.106 4.106 0 0 1 2.886-1.2h.058a4.034 4.034 0 0 1 3.673 2.128l.087.175h2.478l-.437-.991a5.739 5.739 0 0 0-2.274-2.507 6.651 6.651 0 0 0-3.469-.986h-.117a6.46 6.46 0 0 0-4.635 1.953 6.264 6.264 0 0 0-.117 8.861l.175.175a6.535 6.535 0 0 0 4.576 1.866h.058a6.246 6.246 0 0 0 5.859-3.5l.408-.874h-2.478z",
    className: "cls-1",
    transform: "translate(-230.044 -55.597)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_20479",
    d: "M360.765 63.8h-.408a6 6 0 0 0-4.343 1.865 6.4 6.4 0 0 0-.114 9.035.773.773 0 0 0 .175.146 6.06 6.06 0 0 0 4.343 1.807h.087a6.336 6.336 0 0 0 5.946-4.285l.146-.466h-2.332l-.087.2a3.73 3.73 0 0 1-3.614 2.332 4.171 4.171 0 0 1-2.827-1.02 4.006 4.006 0 0 1-1.312-2.274h10.319v-1.161a6 6 0 0 0-1.749-4.139 6.285 6.285 0 0 0-4.227-2.04m3.673 5.218h-7.961a3.717 3.717 0 0 1 1.341-2.04 4.293 4.293 0 0 1 5.334.029 4.2 4.2 0 0 1 1.283 2.011",
    className: "cls-1",
    transform: "translate(-264.247 -55.455)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Rectangle_4435",
    d: "M0 0H2.215V16.294H0z",
    className: "cls-1",
    transform: "translate(104.044 4.605)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_20480",
    d: "M422.531 63.982a5.8 5.8 0 0 0-4.547 1.836 6.469 6.469 0 0 0-.146 9.007 5.958 5.958 0 0 0 4.343 1.924h.233a5.907 5.907 0 0 0 4.314-1.836 6.378 6.378 0 0 0 .146-8.978 5.986 5.986 0 0 0-4.343-1.953m3.877 6.3a4.242 4.242 0 0 1-1.224 3.09 3.663 3.663 0 0 1-2.769 1.224h-.233a3.747 3.747 0 0 1-2.769-1.312 4.109 4.109 0 0 1-1.108-2.973 4.031 4.031 0 0 1 1.224-2.915 3.791 3.791 0 0 1 2.8-1.2h.087a3.521 3.521 0 0 1 2.74 1.2 3.882 3.882 0 0 1 1.253 2.886",
    className: "cls-1",
    transform: "translate(-308.16 -55.578)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_20481",
    d: "M474.288 72.57a4.172 4.172 0 0 1-3.731 2.011 4.255 4.255 0 0 1-4.285-4.2 3.943 3.943 0 0 1 1.37-3 4.106 4.106 0 0 1 2.886-1.2h.058a4.034 4.034 0 0 1 3.673 2.128l.117.175h2.448l-.437-.991a5.739 5.739 0 0 0-2.274-2.507 6.651 6.651 0 0 0-3.469-.986h-.117a6.46 6.46 0 0 0-4.635 1.953 6.264 6.264 0 0 0-.117 8.861l.175.175a6.535 6.535 0 0 0 4.576 1.866h.058a6.246 6.246 0 0 0 5.859-3.5l.408-.845h-2.478z",
    className: "cls-1",
    transform: "translate(-342.087 -55.597)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_20482",
    d: "M520.966 65.865A6 6 0 0 0 516.623 64h-.233a6.122 6.122 0 0 0-4.343 1.924 6.258 6.258 0 0 0-1.749 4.431 6.387 6.387 0 0 0 1.895 4.605 6.207 6.207 0 0 0 8.482.262v5.334h2.215V70.413a5.975 5.975 0 0 0-1.924-4.547m-.35 4.664a4.106 4.106 0 0 1-1.2 2.886 3.79 3.79 0 0 1-2.769 1.2 3.874 3.874 0 0 1-2.886-1.2 4.014 4.014 0 0 1-1.224-2.886 4.087 4.087 0 0 1 1.108-2.944 3.8 3.8 0 0 1 2.769-1.312h.233a3.608 3.608 0 0 1 2.769 1.224 4.154 4.154 0 0 1 1.2 3.031",
    className: "cls-1",
    transform: "translate(-374.891 -55.595)"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_5544",
    transform: "translate(64.755 24.947)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_20483",
    d: "M268.1 129.474V120.7h4.343v.874h-3.5v3.061h3.5v.874h-3.5v3.964z",
    className: "cls-1",
    transform: "translate(-268.1 -120.7)"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_5545",
    transform: "translate(70.027 24.947)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_20484",
    d: "M286 130.856a3.5 3.5 0 0 1 .991-2.507 3.168 3.168 0 0 1 2.361-1.049 3.484 3.484 0 0 1 3.469 3.439 3.519 3.519 0 0 1-.991 2.536 3.2 3.2 0 0 1-2.419 1.049 3.346 3.346 0 0 1-2.448-1.02 3.411 3.411 0 0 1-.963-2.448zm.874-.029a2.685 2.685 0 0 0 .729 1.924 2.363 2.363 0 0 0 1.807.787 2.3 2.3 0 0 0 1.778-.787 2.816 2.816 0 0 0 .729-1.924 2.593 2.593 0 0 0-.729-1.924 2.526 2.526 0 0 0-1.866-.758 2.331 2.331 0 0 0-1.749.787 2.8 2.8 0 0 0-.699 1.895z",
    className: "cls-1",
    transform: "translate(-286 -125.376)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_20485",
    d: "M313.674 134.5h-.874v-6.617h.787v.758a2.3 2.3 0 0 1 .67-.641 1.62 1.62 0 0 1 .874-.2v.933a1.716 1.716 0 0 0-1.131.467 1.964 1.964 0 0 0-.35 1.312v3.988z",
    className: "cls-1",
    transform: "translate(-304.988 -125.73)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_20486",
    d: "M335.8 120.7h1.632a3.448 3.448 0 0 1 2.186.554 2.468 2.468 0 0 1 .466 2.769 1.79 1.79 0 0 1-.7.7 2.588 2.588 0 0 1 1.078.816 2.315 2.315 0 0 1 .35 1.312 2.369 2.369 0 0 1-.729 1.953 3.6 3.6 0 0 1-2.332.612H335.8zm.816.845v2.944h.525a3.258 3.258 0 0 0 1.778-.35 1.271 1.271 0 0 0 .5-1.166 1.3 1.3 0 0 0-.5-1.108 2.732 2.732 0 0 0-1.574-.35h-.729zm0 3.789v3.294h1.224a2.6 2.6 0 0 0 1.574-.408 1.439 1.439 0 0 0 .5-1.253 1.527 1.527 0 0 0-.525-1.253 2.6 2.6 0 0 0-1.574-.408h-1.2z",
    className: "cls-1",
    transform: "translate(-321.284 -120.7)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_20487",
    d: "M356.8 128.1h.845v3.527a3.225 3.225 0 0 0 .437 1.924 1.733 1.733 0 0 0 1.457.554 2.074 2.074 0 0 0 .991-.233 1.718 1.718 0 0 0 .7-.67 1.892 1.892 0 0 0 .2-.612 10.447 10.447 0 0 0 .058-1.224V128.1h.845v6.617h-.816v-.729a2.082 2.082 0 0 1-.874.67 3.3 3.3 0 0 1-1.137.2 2.518 2.518 0 0 1-2.07-.787 4.18 4.18 0 0 1-.641-2.565z",
    className: "cls-1",
    transform: "translate(-336.163 -125.943)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_20488",
    d: "M379 132.222h.874v.029a1.5 1.5 0 0 0 .35 1.02 1.168 1.168 0 0 0 1.691.087.975.975 0 0 0 .321-.787 1.041 1.041 0 0 0-.262-.758 2.377 2.377 0 0 0-.962-.554 3.4 3.4 0 0 1-1.428-.787 1.628 1.628 0 0 1-.35-1.108 1.7 1.7 0 0 1 .554-1.312 1.94 1.94 0 0 1 1.37-.554 1.851 1.851 0 0 1 1.341.5 1.82 1.82 0 0 1 .525 1.341h-.816a1.113 1.113 0 0 0-.291-.729 1.016 1.016 0 0 0-.729-.262.9.9 0 0 0-.7.291.965.965 0 0 0-.292.7.875.875 0 0 0 .5.845 4.23 4.23 0 0 0 .7.291c.321.087.525.175.612.2a1.779 1.779 0 0 1 1.2 1.807 1.933 1.933 0 0 1-.583 1.428 2.116 2.116 0 0 1-1.516.554 1.934 1.934 0 0 1-1.487-.612 2.487 2.487 0 0 1-.622-1.63z",
    className: "cls-1",
    transform: "translate(-351.892 -125.518)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_20489",
    d: "M397.845 122.07H397v-1.37h.845zm-.845 7.4v-6.617h.845v6.617z",
    className: "cls-1",
    transform: "translate(-364.645 -120.7)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_20490",
    d: "M404.529 127.817h.816v.758a2.526 2.526 0 0 1 .9-.67 2.97 2.97 0 0 1 1.166-.2 3.1 3.1 0 0 1 1.312.262 2.146 2.146 0 0 1 .9.787 2.433 2.433 0 0 1 .321.845 8.384 8.384 0 0 1 .087 1.4v3.469h-.845v-3.7a2.613 2.613 0 0 0-.437-1.691 1.787 1.787 0 0 0-1.428-.525 2.287 2.287 0 0 0-1.02.233 1.718 1.718 0 0 0-.7.67 1.912 1.912 0 0 0-.233.612 10.25 10.25 0 0 0-.058 1.2v3.206h-.81v-6.646z",
    className: "cls-1",
    transform: "translate(-369.959 -125.66)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_20491",
    d: "M433.85 131.26h-5.975a2.582 2.582 0 0 0 .787 1.749 2.469 2.469 0 0 0 1.749.67 2.4 2.4 0 0 0 1.341-.379 2.6 2.6 0 0 0 .933-1.078h.962a3.8 3.8 0 0 1-1.283 1.691 3.134 3.134 0 0 1-1.924.583 3.346 3.346 0 0 1-2.448-1.02A3.432 3.432 0 0 1 427 131a3.36 3.36 0 0 1 .991-2.507 3.316 3.316 0 0 1 2.507-.991 3.253 3.253 0 0 1 2.448 1.02 3.717 3.717 0 0 1 .933 2.682v.058zm-.933-.758a3.232 3.232 0 0 0-.874-1.661 2.464 2.464 0 0 0-1.691-.554 2.317 2.317 0 0 0-1.632.612 2.584 2.584 0 0 0-.816 1.632h5.014z",
    className: "cls-1",
    transform: "translate(-385.901 -125.518)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_20492",
    d: "M452.4 132.222h.874v.029a1.5 1.5 0 0 0 .35 1.02 1.135 1.135 0 0 0 .874.408 1.27 1.27 0 0 0 .845-.321.975.975 0 0 0 .321-.787 1.042 1.042 0 0 0-.262-.758 2.77 2.77 0 0 0-.962-.554 3.4 3.4 0 0 1-1.428-.787 1.628 1.628 0 0 1-.35-1.108 1.7 1.7 0 0 1 .554-1.312 1.94 1.94 0 0 1 1.37-.554 1.851 1.851 0 0 1 1.341.5 1.82 1.82 0 0 1 .525 1.341h-.9a1.113 1.113 0 0 0-.291-.729.97.97 0 0 0-.729-.262 1 1 0 0 0-.991.991.875.875 0 0 0 .5.845 3.366 3.366 0 0 0 .7.291c.321.087.525.175.612.2a1.779 1.779 0 0 1 1.2 1.807 1.933 1.933 0 0 1-.583 1.428 2.116 2.116 0 0 1-1.516.554 1.934 1.934 0 0 1-1.487-.612 2.8 2.8 0 0 1-.567-1.63z",
    className: "cls-1",
    transform: "translate(-403.897 -125.518)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_20493",
    d: "M468.9 132.222h.874v.029a1.5 1.5 0 0 0 .35 1.02 1.168 1.168 0 0 0 1.691.087.975.975 0 0 0 .321-.787 1.041 1.041 0 0 0-.262-.758 2.377 2.377 0 0 0-.962-.554 3.4 3.4 0 0 1-1.428-.787 1.628 1.628 0 0 1-.35-1.108 1.7 1.7 0 0 1 .554-1.312 1.94 1.94 0 0 1 1.37-.554 1.851 1.851 0 0 1 1.341.5 1.82 1.82 0 0 1 .525 1.341h-.9a1.113 1.113 0 0 0-.292-.729 1.016 1.016 0 0 0-.729-.262.9.9 0 0 0-.7.291.965.965 0 0 0-.291.7.875.875 0 0 0 .5.845 4.232 4.232 0 0 0 .7.291c.321.087.525.175.612.2a1.779 1.779 0 0 1 1.2 1.807 1.933 1.933 0 0 1-.583 1.428 2.116 2.116 0 0 1-1.516.554 1.934 1.934 0 0 1-1.487-.612 2.3 2.3 0 0 1-.538-1.63z",
    className: "cls-1",
    transform: "translate(-415.588 -125.518)"
  })), /*#__PURE__*/React.createElement("path", {
    id: "Path_20494",
    d: "M121.148 80.527a7.005 7.005 0 0 0-.321-.67l1.457-.816c.146.291.291.583.408.874zm-.729-1.312a4.481 4.481 0 0 0-.5-.554l1.166-1.224a5 5 0 0 1 .641.729zm-1.078-1.049a4.64 4.64 0 0 0-.641-.379l.758-1.487c.291.146.554.321.845.5z",
    className: "cls-2",
    transform: "translate(-97.538 -64.311)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_20495",
    d: "M105.1 87.025a3.728 3.728 0 1 1-4.6-2.565 3.728 3.728 0 0 1 4.605 2.565",
    className: "cls-2",
    transform: "translate(-82.719 -69.99)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_20496",
    d: "M126.4 97.3l1.108 1.108a6.616 6.616 0 0 0 1.049-3.614c0-.321-.029-.67-.058-.991l-1.516.233a5.107 5.107 0 0 1-.583 3.264",
    className: "cls-1",
    transform: "translate(-102.994 -76.706)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_20497",
    d: "M96.523 85.426a5.234 5.234 0 1 1-1.108-9.765l.408-1.457a6.484 6.484 0 0 0-1.661-.2 6.762 6.762 0 1 0 0 13.525 6.622 6.622 0 0 0 3.469-.962z",
    className: "cls-1",
    transform: "translate(-75.362 -62.678)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Rectangle_4436",
    d: "M0 0H1.516V7.462H0z",
    className: "cls-2",
    transform: "rotate(-45 33.183 -13.267)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_20498",
    d: "M79.263 43.549V35.3A18.619 18.619 0 0 0 67.4 40.139l5.713 5.946a10.292 10.292 0 0 1 6.15-2.536z",
    className: "cls-1",
    transform: "translate(-61.191 -35.271)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_20499",
    d: "M141.374 69.534h8.249a18.648 18.648 0 0 0-4.548-11.834l-5.975 5.713a10.471 10.471 0 0 1 2.274 6.121z",
    className: "cls-1",
    transform: "translate(-111.972 -51.135)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_20500",
    d: "M119.729 46.335l5.946-5.713A18.745 18.745 0 0 0 113.2 35.2v8.249a10.89 10.89 0 0 1 6.529 2.886z",
    className: "cls-1",
    transform: "translate(-93.641 -35.2)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_20501",
    d: "M139.857 103.5a10.578 10.578 0 0 1-2.857 6.179l5.713 5.946a18.932 18.932 0 0 0 5.422-12.126z",
    className: "cls-2",
    transform: "translate(-110.485 -83.566)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_20502",
    d: "M119 128.2a10.5 10.5 0 0 1-5.8 2.244v8.249a18.847 18.847 0 0 0 11.514-4.547z",
    className: "cls-2",
    transform: "translate(-93.641 -101.067)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_20503",
    d: "M72.475 127.2l-5.975 5.713a18.808 18.808 0 0 0 12.126 5.072v-8.249a10.441 10.441 0 0 1-6.151-2.536z",
    className: "cls-1",
    transform: "translate(-60.554 -100.358)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_20504",
    d: "M54.478 103.5H46.2a18.7 18.7 0 0 0 4.839 11.543l5.975-5.713a10.365 10.365 0 0 1-2.536-5.83z",
    className: "cls-1",
    transform: "translate(-46.171 -83.572)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_20505",
    d: "M56.914 61.475L51.2 55.5a18.929 18.929 0 0 0-5.1 12.476h8.249a10.493 10.493 0 0 1 2.565-6.501z",
    className: "cls-1",
    transform: "translate(-46.1 -49.577)"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogo);
export default __webpack_public_path__ + "static/media/logo.6a2338c93f39941ed65037ea82232941.svg";
export { ForwardRef as ReactComponent };